import React, { useContext, useState, useEffect } from 'react';
import ItemRow from './itemRow/itemRow';
import HeaderType from './headerType/headerType';
import InputText from './forms/inputText';
import { PokedexContext } from '../Data/Context/pokemonData';
import { BuildContext } from '../Data/Context/buildData';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getUserFromLocalStorage } from '../utils/localStorage';
import Notes from './notes/notes';
import LoadingAnimation from './loadingAnimation';
import { LanguageContext } from '../Data/Context/languageContext';

const BuilderContent = () => {
    const { pokemonData } = useContext(PokedexContext);
    const { updateBuildTitle, buildDataFromDB } = useContext(BuildContext);
    const [buildTitle, setBuildTitle] = useState('');
    const [buildTitleDB, setBuildTitleDB] = useState(buildDataFromDB && buildDataFromDB.title ? buildDataFromDB.title : '');
    let numberOfAbilities = pokemonData.numberOf.abilities;
    const { viewingID, editingID } = useParams();
    const user_session = getUserFromLocalStorage();
    const customId = "custom-id-yes";
    let abilitiesRow;
    let personalitiesRow;
    let heldItemsRow;
    let gearRow;
    let hiddenSkillsRow;
    const { t } = useContext(LanguageContext);
    const [isLoaded, setIsLoaded] = useState();

    const notify = () => {
        toast.warn(t("toast_must_be_logged_in"), {
            toastId: customId,
            autoClose: false
        });
    }

    useEffect(() => {
        if (editingID) {
            updateBuildTitle(buildTitleDB);
        } else {
            updateBuildTitle(buildTitle);
        }

        if (!viewingID && !user_session) {
            notify();
        }
        // eslint-disable-next-line
    }, [buildTitle, buildTitleDB]);

    useEffect(() => {
        setTimeout(() => {
            setIsLoaded(true);
        }, 500);
    }, []);

    // eslint-disable-next-line
    if ((!viewingID && !editingID) || (editingID) || viewingID && (buildDataFromDB && buildDataFromDB.abilities.ability_1)) {
        abilitiesRow = <ItemRow id="builder-abilities" title={t("abilities")} itemCategory={'Ability'} numberOfItems={numberOfAbilities} itemType={'ability'} disabled={false} modal="#abilities-modal" />
    }
    // eslint-disable-next-line
    if ((!viewingID && !editingID) || (editingID) || viewingID && (buildDataFromDB && buildDataFromDB.personalities.personality_1)) {
        personalitiesRow = <ItemRow id="builder-personality" title={t("personalities")} itemCategory={'Nature'} itemType={'personality'} disabled={false} modal="#personalities-modal" />
    }
    // eslint-disable-next-line
    if ((!viewingID && !editingID) || (editingID) || viewingID && (buildDataFromDB && buildDataFromDB.heldItems.held_item_1)) {
        heldItemsRow = <ItemRow id="builder-held-items" title={t("held_items")} itemCategory={'Item'} itemType={'heldItem'} disabled={false} modal="#heldItems-modal" />
    }
    // eslint-disable-next-line
    if ((!viewingID && !editingID) || (editingID) || viewingID && (buildDataFromDB && buildDataFromDB.gear.gear_1)) {
        gearRow = <ItemRow id="builder-gear" title={t("gear")} itemCategory={'Gear'} numberOfItems={4} itemType={'gear'} disabled={false} modal="#gears-modal" />
    }
    // eslint-disable-next-line
    if ((!viewingID && !editingID) || (editingID) || viewingID && (buildDataFromDB && buildDataFromDB.heldItems.held_item_1)) {
        hiddenSkillsRow = <ItemRow id="builder-hidden-skills" title={t("hidden_skills")} itemCategory={'Skill'} itemType={'hiddenSkill'} disabled={false} modal="#hiddenSkills-modal" />
    }

    if (!isLoaded) {
        return <LoadingAnimation />
    } else {
        return (
            <div className="col-lg-7 col-xl-8 col-xxl-9 custom-border rounded-3 mb-5">
                {
                    <>
                        <HeaderType />
                        <form className='form-builder'>
                            {editingID &&
                                <InputText isFormTitle={true} setBuildTitle={setBuildTitleDB} value={buildDataFromDB ? buildDataFromDB.title : ''}>{t("build_title")}</InputText>
                            }

                            {!viewingID && !editingID &&
                                <InputText isFormTitle={true} setBuildTitle={setBuildTitle}>{t("build_title")}</InputText>
                            }

                            {viewingID && buildDataFromDB && buildDataFromDB.title &&
                                <Notes classes={'pt-3'} itemType={'title'} notes={buildDataFromDB.title}></Notes>
                            }

                            {abilitiesRow}
                            {personalitiesRow}
                            {heldItemsRow}
                            {gearRow}
                            {hiddenSkillsRow}

                            {editingID &&
                                <>
                                    <div className='d-flex flex-column flex-sm-row justify-content-end d-grid gap-3 col-8 col-sm-12 mx-auto mb-4 pe-0 pe-sm-2'>
                                        <button className='btn btn-danger' type="button" data-bs-toggle="modal" data-bs-target="#deleteBuild-modal">{t("delete_build")} <i className="fa-solid fa-trash"></i></button>
                                        <button className='btn btn-success' type="button" data-bs-toggle="modal" data-bs-target="#saveshare-modal">{t("save_changes")} <i className="fa-solid fa-floppy-disk"></i></button>
                                    </div>
                                </>
                            }

                            {(!viewingID && !editingID) &&
                                <div className='d-flex justify-content-end mb-4 pe-2'>
                                    <button className='btn btn-info' type="button" data-bs-toggle="modal" data-bs-target="#saveshare-modal">{t("create_build")} <i className="fa-solid fa-circle-chevron-right"></i></button>
                                </div>
                            }
                        </form>
                    </>
                }
            </div>
        )
    }
}
export default BuilderContent;